import { Base } from "../../framework/base";
import { IIdTitleNode, IdTitleNode } from "../common/idTitleNode";
import { IRecordFurtherEducationNode, RecordFurtherEducationNode } from "../recordFurtherEducation/recordFurtherEducationNode";

export interface IRecordFurtherEducationGroupNode {
    id: string;
    code: string;
    comment: string;
    requiredQualificationCount: number;
    children: IRecordFurtherEducationNode[];

    collapsed: boolean;

    getRecordFurtherEducationById(id: string): IRecordFurtherEducationNode;
}

export class RecordFurtherEducationGroupNode implements IRecordFurtherEducationGroupNode {
    id: string;
    code: string;
    comment: string;
    requiredQualificationCount: number;
    children: RecordFurtherEducationNode[];

    collapsed: boolean;

    constructor();
    constructor(obj: IRecordFurtherEducationGroupNode);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.requiredQualificationCount = obj && obj.requiredQualificationCount || 0;
        this.children = Base.getTypedArray(obj ? obj.children : null, RecordFurtherEducationNode);
        for (const child of this.children) {
            child.parent = this;
        }
        this.collapsed = obj && obj.collapsed || false;
    }

    getRecordFurtherEducationById(id: string): IRecordFurtherEducationNode {
        for (const child of this.children) {
            if (id !== child.id) continue;
            return child;
        }
        return null;
    }

    static isGroup = (arg: any): arg is IRecordFurtherEducationGroupNode => {
        return arg.children !== undefined;
    };

    static getRecordFurtherEducationById(items: IRecordFurtherEducationGroupNode[], id: string): IRecordFurtherEducationNode {
        if (!items || items.length < 1) return null;
        for (const item of items) {
            const result = item.getRecordFurtherEducationById(id);
            if (!result) continue;
            return result;
        }
        return null;
    }

    static getRecordFurtherEducationGroupNodeById(items: IRecordFurtherEducationGroupNode[], id: string): IRecordFurtherEducationGroupNode {
        if (!items || items.length < 1) return null;
        return items.find(i => i.id === id);
    }

    static getItemById(items: IRecordFurtherEducationGroupNode[], id: string): IRecordFurtherEducationGroupNode | IRecordFurtherEducationNode {
        if (!items || items.length < 1) return null;
        for (const item of items) {
            if (item.id === id) return item;
            const result = item.getRecordFurtherEducationById(id);
            if (!result) continue;
            return result;
        }
        return null;
    }

    static getFirstRecordFurtherEducationById(items: IRecordFurtherEducationGroupNode[]): IRecordFurtherEducationNode {
        if (!items || items.length < 1) return null;
        for (const item of items) {
            if (!item.children.length) continue;
            return item.children[0];
        }
        return null;
    }
    
    static getRecordFurtherEducationCount(items: IRecordFurtherEducationGroupNode[]): number {
        if (!items || items.length < 1) return 0;
        let result = 0;
        for (const item of items) {
            result = result + item.children.length;
        }
        return result;
    }

    static getAsList(items: IRecordFurtherEducationGroupNode[]): (IRecordFurtherEducationGroupNode | IRecordFurtherEducationNode)[] {
        if (!items || items.length < 1) return [];
        let result: (IRecordFurtherEducationGroupNode | IRecordFurtherEducationNode)[] = [];
        for (const item of items) {
            result.push(item);
            result = result.concat(item.children);
        }
        return result;
    }
    
    static equalIdsInArrays(a: IRecordFurtherEducationGroupNode[], b: IRecordFurtherEducationGroupNode[]): boolean {
        return Base.equalStrArrays(RecordFurtherEducationGroupNode.getAsList(a).map(i => i.id), RecordFurtherEducationGroupNode.getAsList(b).map(i => i.id));
    }

    static getFurtherEducations = (furtherEducationGroups: IRecordFurtherEducationGroupNode[]): IIdTitleNode[] => {
        if (!furtherEducationGroups || furtherEducationGroups.length < 1) return [];
        return furtherEducationGroups.map(i =>
            IdTitleNode.createIdTitleNode(
                i.id,
                i.code,
                i.children.map(j => IdTitleNode.createIdTitleNode(
                    j.id,
                    j.code,
                    [],
                    true,
                    [
                        { key: "scopeUnit", value: j.scopeUnit.toString(10) },
                        { key: "scope", value: j.scope.toString(10) },
                        { key: "validity", value: j.validity.toString(10) }
                    ])),
                false)
        );
    };

    static getFurtherEducationsForQualification = (furtherEducationGroups: IRecordFurtherEducationGroupNode[]): IIdTitleNode[] => {
        if (!furtherEducationGroups || furtherEducationGroups.length < 1) return [];
        return furtherEducationGroups.map(i =>
            IdTitleNode.createIdTitleNode(i.id, i.code, i.children.map(j => IdTitleNode.createIdTitleNode(j.id, j.code, [], i.requiredQualificationCount === 0, [{ key: "scopeUnit", value: j.scopeUnit.toString(10) }])), i.requiredQualificationCount > 0)
        );
    };
}